import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AuthHeader } from '@app/shared/components/header/auth-header/auth-header';

@Component({
  selector: 'app-auth-layout',
  imports: [CommonModule, RouterOutlet, AuthHeader],
  templateUrl: './auth-layout.html',
  styleUrl: './auth-layout.scss',
})
export class AuthLayout {}
